import { render, staticRenderFns } from "./ApplicationsDetailsPricing.vue?vue&type=template&id=70358572&scoped=true"
import script from "./ApplicationsDetailsPricing.vue?vue&type=script&lang=js"
export * from "./ApplicationsDetailsPricing.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsDetailsPricing.vue?vue&type=style&index=0&id=70358572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70358572",
  null
  
)

export default component.exports